const VLD = {}

VLD.reg = {
	text: /^[а-яА-Яa-zA-ZёЁ\-\s]{2,}$/,
	textNums: /^[а-яА-Яa-zA-ZёЁ0-9\-\s]{2,}$/,
	textEn: /^[a-zA-Z\-\s]{2,}$/,
	textEnNums: /^[a-zA-Z0-9\-\s]{2,}$/,
	textRu: /^[а-яА-ЯёЁ\-\s]{2,}$/,
	textRuNums: /^[а-яА-ЯёЁ0-9\-\s]{2,}$/,
	textArea: /^[^]{5,}$/,
	phone: /^\+7\(?[0-9]{3}\)?[0-9-]{9}$/,
	phoneRaw: /^\+7[0-9]{10}$/,
	code4: /^[0-9]{4}$/,
	email: /[a-zA-Z0-9\-\_\.\&]+@[a-zA-Z0-9\-\_]+\.\S+/,
	date: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
	vkLink: /^(?:(?:http|https):\/\/)(vk\.com\/)[a-zA-z0-9]+$/,
	year: /^[0-9\-\s]+$/,
	url: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([a-zA-Z\.#-=?\/])*$/,
	promocode: /[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}/,
	password: /^[a-zA-Z0-9\s]{5,}$/,
	rgba: /^rgba[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*,){3}\s*0*(?:\.\d+|1(?:\.0*)?)\s*[)]$/,
}

VLD.check = function(inp, reg) {
	if (inp.match(VLD.reg[reg])) {
		return true
	} else {
		return false
	}
}

VLD.checkBox = function(inp) {
	var check = inp.prop('checked')

	if (check) {
		return true
	} else {
		return false
	}
}

VLD.bool = function(inp) {
	if (!inp.constructor === Boolean) {
		return false
	}

	return true
}

export default VLD
